import PageStore from './PageStore';
import LoadStore from './LoadStore';
export {PageStore, LoadStore};



// WEBPACK FOOTER //
// ./src/stores/index.js